import React, {Component} from 'react';
import SearchFieldPlace from './search_field_place.component'
import SearchFieldGuests from './search_field_guests.component'
import SearchFieldDates from './search_field_dates.component'
import SearchPanelCycles from './search_panel_cycles.component'
import OutsideAlerter from '../../hoc/OutsideAlerter.hoc'
import withNofeshService  from '../../hoc/withNofeshService.hoc';
import compose from '../../utils/compose'
import Spinner from 'react-bootstrap/Spinner'
import { Redirect } from "react-router-dom";
import { AppDataParam ,WeekPeriodId } from '../../utils/constUtils'



class SearchPanel extends Component {


    state = {
        redirect : null,
        shouldCloseSearchFieldPlace : false,
        shouldCloseSearchFieldGuests : false,
        shouldCloseSearchFieldDates : false,
        loading : false,
        showMsg:false,
        message:''
    }

    

    componentDidMount = () => {
                 

    }
  




    toggleWeekDays = (weekDaysFlag) =>{
        const data = {
            search_param_weekdays : weekDaysFlag
        };
    
        this.props.setCurrentAppData(data, AppDataParam.set_app_data);
        
    }

    isWeekDaysSelected = (weekDaysFlag) =>{
        const { currentSearchObj }= this.props; 
        if (currentSearchObj.search_param_weekdays == weekDaysFlag)  
            return true;

        return false;
    }

    updateSearchFieldsState =  (data) => {

        if (data.SearchFieldGuestsOpened)
        {
            this.setState({shouldCloseSearchFieldPlace:true});  
            this.setState({shouldCloseSearchFieldGuests:false});  
            this.setState({shouldCloseSearchFieldDates:true});  
        }

        if (data.SearchFieldPlaceOpened)
        {
            this.setState({shouldCloseSearchFieldGuests:true}); 
            this.setState({shouldCloseSearchFieldPlace:false});   
            this.setState({shouldCloseSearchFieldDates:true});  
        }

        if (data.SearchFieldDatesOpened)
        {
            this.setState({shouldCloseSearchFieldGuests:true}); 
            this.setState({shouldCloseSearchFieldPlace:true});   
            this.setState({shouldCloseSearchFieldDates:false});  
        }


    }

    closeSelfSearchFieldPlace = () => {        
        this.setState({shouldCloseSearchFieldPlace:true}); 
    }
    closeSelfSearchFieldGuests = () => {
        this.setState({shouldCloseSearchFieldGuests:true}); 
    }
          
    closeSelfSearchFieldDates = () => {
        this.setState({shouldCloseSearchFieldDates:true}); 
    }
   

    searchMain = () => {       
        const { nofeshService } = this.props;
        const { currentSearchObj }= this.props;    
        console.log('search main currentSearchObj', currentSearchObj);
        
        if (currentSearchObj.searchFieldDates_placeholder == '' ||
            currentSearchObj.searchFieldDates_placeholder == 'מועדים') {
            this.setState({ showMsg: true, message:'יש לבחור תאריכים לחיפוש.'}); 
            return;
        }

        //currentSearchObj.personsChildren
        //dates
        //currentSearchObj.search_param_dates_months = data.search_param_dates_months;
        //currentSearchObj.search_param_dates_range = data.search_param_dates_range;
        //currentSearchObj.search_by_dates = data.search_by_dates;
        nofeshService.validateSearchHotelsForOrder(currentSearchObj).then( res  => {    
            console.log('SearchPanel searchMain res.data: ', res.data);
            let  resultObj = res.data;
            if ( res.data.status == "1") {
                this.props.setCurrentAppData(null, AppDataParam.reset_last_chance);
                this.setState({ redirect: "/results"});
            }
            else {
                this.setState({ showMsg: true, message: res.data.message});
            }
  
        }).catch(function(error) {
            console.log('SearchPanel searchMain nofeshService ERROR: ',error);
        }).finally(() => {
    
        });


        /*
        if (currentSearchObj.searchFieldDates_placeholder == '' ||
            currentSearchObj.searchFieldDates_placeholder == 'מועדים') {
            this.setState({ showMsg: true, message:'יש לבחור תאריכים לחיפוש.'}); 
        }  else {
             //new 
            this.props.setCurrentAppData(null, AppDataParam.reset_last_chance);
            this.setState({ redirect: "/results"});
        }
        */
    }


    setCurrentAppData_local = (data,param)  => {

        if(param == AppDataParam.set_app_data) {
            this.setState({showMsg:false}); 
        }
        this.props.setCurrentAppData(data,param);
    }

   

    render() { 
        if (this.state.redirect) {
            return <Redirect to={this.state.redirect} />
        }        
 

        let noEntitlementsAlailiable = false;
        if ( this.props.personData.hasEntitlementsNotOrdered == 0 && 
             this.props.personData.hasEntitlementsOrderedNotRealized == 0) 
             {
                noEntitlementsAlailiable = true;
             }

        return (            
            <div className="cntered-flex" >

                {(noEntitlementsAlailiable) ?
                    <div className="hp_search_box">                    
                        <div className="hp_search_title">
                            <div className="hp_search_title_inner_div">
                                <div className="paddingTop15">חפש את חופשתך הבאה</div>
                            </div>
                        </div>	

                        <div className="cntered-flex directionRtl">
                            <div className="cntered-flex hp_search_width300 calendarinnerTitle">
                              לא נמצא זכאות
                            </div>
                        </div>
                    </div>
                 : null}


                {(!noEntitlementsAlailiable) ?
                    <div className="hp_search_box">                    
                        <div className="hp_search_title">
                            <div className="hp_search_title_inner_div">
                                <div className="paddingTop15">חפש את חופשתך הבאה</div>
                            </div>
                        </div>		


                        <SearchPanelCycles 
                            personData={this.props.personData}
                            currentSearchObj={this.props.currentSearchObj}
                            setCurrentAppData={this.props.setCurrentAppData} />

                        

                        <div className="hp_search_allfields_container">
                            <div className="allfields_child-table">
                            <OutsideAlerter closeSelfSearchField={this.closeSelfSearchFieldPlace} OutsideClassName="hp_search_outside_container">
                                <SearchFieldPlace  
                                    personData={this.props.personData}
                                    updateOpenSearchFieldFn={this.updateSearchFieldsState} 
                                    shouldClose={this.state.shouldCloseSearchFieldPlace}
                                    setCurrentAppData={this.props.setCurrentAppData} 
                                    currentSearchObj={this.props.currentSearchObj}
                                />
                            </OutsideAlerter>
                            </div>

                            <div className="allfields_child-table">
                            <OutsideAlerter closeSelfSearchField={this.closeSelfSearchFieldGuests} OutsideClassName="hp_search_outside_container">
                                <SearchFieldGuests 
                                    personData={this.props.personData}
                                    currentSearchObj={this.props.currentSearchObj}
                                    updateOpenSearchFieldFn={this.updateSearchFieldsState} 
                                    shouldClose={this.state.shouldCloseSearchFieldGuests} 
                                    setCurrentAppData={this.props.setCurrentAppData}
                                />
                            </OutsideAlerter>
                            </div>
                            
                            <div className="allfields_child-table">
                            <OutsideAlerter closeSelfSearchField={this.closeSelfSearchFieldDates} OutsideClassName="hp_search_outside_container">
                                <SearchFieldDates 
                                    personData={this.props.personData}
                                    currentSearchObj={this.props.currentSearchObj}
                                    updateOpenSearchFieldFn={this.updateSearchFieldsState} 
                                    shouldClose={this.state.shouldCloseSearchFieldDates}
                                    setCurrentAppData={this.setCurrentAppData_local}   
                                />
                            </OutsideAlerter>
                            </div>


                            <div className="allfields_child-table">
                            <div className="hp_search_outside_container" >
                                <div className="hp_search_field_container hp_search_field_marginRight15 hp_search_field_marginLeft38">
                                    <div className="daysWeekContainer">
                                        <div  onClick={() => this.toggleWeekDays(WeekPeriodId.WeekAll)}
                                            className={                    
                                            this.isWeekDaysSelected(WeekPeriodId.WeekAll)
                                                ? 'daysWeekCell  selected' 
                                                : 'daysWeekCell  not_selected' }>   
                                                <div className="spanTextRight">
                                                כל ימי
                                                <br />
                                                     השבוע  
                                                </div>  
                                        </div>

                                        <div className="horizontal_Line_weekDays"></div>                                    

                                        <div  onClick={() => this.toggleWeekDays(WeekPeriodId.Weekmiddle)}
                                            className={                    
                                            this.isWeekDaysSelected(WeekPeriodId.Weekmiddle)
                                                ? 'daysWeekCell  selected' 
                                                : 'daysWeekCell  not_selected' }>   
                                                <div className="spanTextRight">
                                                  אמצע
                                                  <br />
                                                  שבוע
                                                </div>
                                            </div>
                                        <div className="horizontal_Line_weekDays"></div>

                                        <div  onClick={() => this.toggleWeekDays(WeekPeriodId.Weekend)}
                                            className={                    
                                            this.isWeekDaysSelected(WeekPeriodId.Weekend)
                                                ? 'daysWeekCell  selected' 
                                                : 'daysWeekCell  not_selected' }>   

                                                <div className="spanTextRight">
                                                    סוף
                                                    <br />
                                                    שבוע
                                                </div>
                                            </div>
                                    </div>
                                </div>
                            </div>
                            </div>

                        </div>

                        <div className="cntered-flex msgPanel">
                            {(this.state.showMsg ) 
                                ? <div className="errorMsg directionRtl">{this.state.message}</div>
                                : null}
                        </div>

                        <div className="cntered-flex ">
                            <div className="hp_search_main_button" onClick={() => this.searchMain()}>

                                {(this.state.loading) ?
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"                                        
                                    />      
                                : null}
                                <span className="hp_search_main_button_title">
                                    מצא חופשה
                                </span> 
                            </div>
                        </div>
                    </div>

                :null}                     
            </div>		
            
        )
    }
}



  export default compose(
    withNofeshService()
  )(SearchPanel);
  